<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    
    <!-- 搜索筛选区域 -->
    <el-row style="margin-bottom: 1rem">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input 
            v-model="searchForm.order_no" 
            placeholder="请输入订单号"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="申请人ID">
          <el-input 
            v-model="searchForm.apply_user_id" 
            placeholder="请输入申请人ID"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="申请类型">
          <el-select 
            v-model="searchForm.account_type" 
            placeholder="请选择"
            clearable
          >
            <el-option label="用户" :value="1"></el-option>
            <el-option label="教练" :value="2"></el-option>
            <el-option label="机构" :value="3"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="状态">
          <el-select 
            v-model="searchForm.status" 
            placeholder="请选择"
            clearable
          >
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过/处理中" :value="1"></el-option>
            <el-option label="审核拒绝" :value="2"></el-option>
            <el-option label="打款成功" :value="3"></el-option>
            <el-option label="打款失败" :value="4"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="提现渠道">
          <el-input 
            v-model="searchForm.channel_type" 
            placeholder="请输入提现渠道"
            clearable
          ></el-input>
        </el-form-item>
        
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      border
      :fit="true"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      v-loading="is_loading"
      style="width: 100%"
    >
      <el-table-column label="ID" prop="id" width="80"></el-table-column>
      
      <el-table-column label="订单号" prop="order_no" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.order_no || '-' }}</span>
        </template>
      </el-table-column>
      
    
      <el-table-column label="申请类型" prop="account_type" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.account_type === 1" type="success">用户</el-tag>
          <el-tag v-else-if="scope.row.account_type === 2" type="warning">教练</el-tag>
          <el-tag v-else-if="scope.row.account_type === 3" type="info">机构</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      
      <el-table-column label="申请金额(元)" prop="amount" width="120">
        <template slot-scope="scope">
          <span style="color: #f56c6c; font-weight: bold;">
            {{ scope.row.amount ? Number(scope.row.amount).toFixed(2) : '0.00' }}
          </span>
        </template>
      </el-table-column>
      
      <el-table-column label="手续费(元)" prop="fee" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.fee ? Number(scope.row.fee).toFixed(2) : '0.00' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="实际打款(元)" prop="actual_amount" width="120">
        <template slot-scope="scope">
          <span style="color: #67c23a; font-weight: bold;">
            {{ scope.row.actual_amount ? Number(scope.row.actual_amount).toFixed(2) : '0.00' }}
          </span>
        </template>
      </el-table-column>
      
      
      <el-table-column label="状态" prop="status" width="140">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="info">待审核</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="warning">审核通过/处理中</el-tag>
          <el-tag v-else-if="scope.row.status === 2" type="danger">审核拒绝</el-tag>
          <el-tag v-else-if="scope.row.status === 3" type="success">打款成功</el-tag>
          <el-tag v-else-if="scope.row.status === 4" type="danger">打款失败</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>

       <el-table-column label="提现人"  width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.person_name || '-' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="提现渠道" prop="channel_type" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.channel_type || '-' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="审核时间" prop="audit_time" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.audit_time || '-' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="审核人" prop="handler_name" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.handler_name || '-' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="到账时间" prop="success_time" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.success_time || '-' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="第三方流水号" prop="third_party_no" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.third_party_no || '-' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="申请时间" prop="create_time" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.create_time || '-' }}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button 
            v-if="scope.row.status === 0"
            type="primary" 
            size="small"
            @click="handleAudit(scope.row)"
          >
            审核
          </el-button>
          <el-button 
            type="text" 
            size="small"
            @click="handleViewDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <paging-fy
      @currentPageChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    ></paging-fy>

    <!-- 审核对话框 -->
    <el-dialog 
      title="提现审核" 
      :visible.sync="auditDialogVisible" 
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="auditForm" label-width="100px">
        <el-form-item label="订单号">
          <span>{{ auditForm.order_no }}</span>
        </el-form-item>
        <el-form-item label="申请金额">
          <span style="color: #f56c6c; font-weight: bold;">
            {{ auditForm.amount ? Number(auditForm.amount).toFixed(2) : '0.00' }} 元
          </span>
        </el-form-item>
        <el-form-item label="审核结果" required>
          <el-radio-group v-model="auditForm.audit_status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注说明" v-if="auditForm.audit_status === 2">
          <el-input 
            type="textarea" 
            v-model="auditForm.remark" 
            placeholder="请输入拒绝原因"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAudit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 详情对话框 -->
    <el-dialog 
      title="提现申请详情" 
      :visible.sync="detailDialogVisible" 
      width="700px"
    >
      <el-descriptions :column="2" border v-if="detailData">
        <el-descriptions-item label="订单号">{{ detailData.order_no }}</el-descriptions-item>
        <el-descriptions-item label="申请人ID">{{ detailData.apply_user_id }}</el-descriptions-item>
        <el-descriptions-item label="申请类型">
          <el-tag v-if="detailData.account_type === 1" type="success">用户</el-tag>
          <el-tag v-else-if="detailData.account_type === 2" type="warning">教练</el-tag>
          <el-tag v-else-if="detailData.account_type === 3" type="info">机构</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="提现人">{{ detailData.person_name }}</el-descriptions-item>
        <el-descriptions-item label="申请金额">
          <span style="color: #f56c6c; font-weight: bold;">
            {{ detailData.amount ? Number(detailData.amount).toFixed(2) : '0.00' }} 元
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="手续费">
          {{ detailData.fee ? Number(detailData.fee).toFixed(2) : '0.00' }} 元
        </el-descriptions-item>
        <el-descriptions-item label="实际打款">
          <span style="color: #67c23a; font-weight: bold;">
            {{ detailData.actual_amount ? Number(detailData.actual_amount).toFixed(2) : '0.00' }} 元
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="提现渠道">{{ detailData.channel_type || '-' }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag v-if="detailData.status === 0" type="info">待审核</el-tag>
          <el-tag v-else-if="detailData.status === 1" type="warning">审核通过/处理中</el-tag>
          <el-tag v-else-if="detailData.status === 2" type="danger">审核拒绝</el-tag>
          <el-tag v-else-if="detailData.status === 3" type="success">打款成功</el-tag>
          <el-tag v-else-if="detailData.status === 4" type="danger">打款失败</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="请求IP">{{ detailData.request_ip || '-' }}</el-descriptions-item>
        <el-descriptions-item label="第三方流水号">{{ detailData.third_party_no || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ detailData.audit_time || '-' }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{ detailData.handler_name || '-' }}</el-descriptions-item>
        <el-descriptions-item label="到账时间">{{ detailData.success_time || '-' }}</el-descriptions-item>
        <el-descriptions-item label="申请时间" :span="2">{{ detailData.create_time }}</el-descriptions-item>
        <el-descriptions-item label="更新时间" :span="2">{{ detailData.update_time }}</el-descriptions-item>
        <el-descriptions-item label="审核/打款失败原因" :span="2">
          {{ detailData.audit_remark || '-' }}
        </el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "WithdrawManageList",
  data() {
    return {
      nav: {
        firstNav: '财务管理中心',
        secondNav: '提现申请管理'
      },
      // 搜索表单
      searchForm: {
        order_no: '',
        apply_user_id: '',
        account_type: null,
        status: null,
        channel_type: '',
        dateRange: []
      },
      // 表格数据
      tableData: [],
      // 加载状态
      is_loading: false,
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 审核对话框
      auditDialogVisible: false,
      auditForm: {
        id: null,
        order_no: '',
        amount: 0,
        audit_status: 1,
        remark: ''
      },
      // 详情对话框
      detailDialogVisible: false,
      detailData: null
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      this.is_loading = true;
      
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        order_no: this.searchForm.order_no || null,
        apply_user_id: this.searchForm.apply_user_id || null,
        account_type: this.searchForm.account_type,
        status: this.searchForm.status,
        channel_type: this.searchForm.channel_type || null
      };
      
      // 处理时间范围
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.start_time = this.searchForm.dateRange[0] + ' 00:00:00';
        params.end_time = this.searchForm.dateRange[1] + ' 23:59:59';
      }
      
      this.$get('user/withdrawalOrders/queryManagerListPage', params)
        .then(res => {
          if (res.data.code === 0) {
            this.tableData = res.data.data.rows || [];
            this.total = res.data.data.total || 0;
          }
        })
        .catch(err => {
          console.error('获取提现列表失败:', err);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    
    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.getList();
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        order_no: '',
        apply_user_id: '',
        account_type: null,
        status: null,
        channel_type: '',
        dateRange: []
      };
      this.currentPage = 1;
      this.getList();
    },
    
    // 分页变化
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    
    // 审核
    handleAudit(row) {
      this.auditForm = {
        id: row.id,
        order_no: row.order_no,
        amount: row.amount,
        audit_status: 1,
        remark: ''
      };
      this.auditDialogVisible = true;
    },
    
    // 确认审核
    confirmAudit() {
      if (this.auditForm.audit_status === 2 && !this.auditForm.remark) {
        this.$message.warning('请输入拒绝原因');
        return;
      }
      
      // 获取当前登录的管理员信息
      const managerInfo = JSON.parse(localStorage.getItem('managerInfo') || '{}');
      
      const url = 'user/withdrawalOrders/audit';
      const data = {
        id: this.auditForm.id,
        status: this.auditForm.audit_status,
        audit_remark: this.auditForm.remark || '',
        handler_id: managerInfo.id || null,
        handler_name: managerInfo.name || ''
      };
      
      this.$post(url, data)
        .then(res => {
          if (res.data.code === 0) {
            this.$message.success('审核成功');
            this.auditDialogVisible = false;
            this.getList();
          }
        })
        .catch(err => {
          console.error('审核失败:', err);
        });
    },
    
    // 查看详情
    handleViewDetail(row) {
      this.detailData = row;
      this.detailDialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
}

.demo-form-inline {
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>
